/* unplugin-vue-components disabled */import script from "./classInfo_copy.vue?vue&type=script&setup=true&lang=js"
export * from "./classInfo_copy.vue?vue&type=script&setup=true&lang=js"

import "./classInfo_copy.vue?vue&type=style&index=0&id=10016bf0&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10016bf0"]])

export default __exports__